import attachmentSchema from './attachment.schema';
import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    attachments: {
      title: 'Załączniki konkursu',
      type: 'array',
      items: attachmentSchema,
      warnings: {
        minItems: 1
      }
    }
  },
  allOf: [validationMessages]
};
